import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Registation from './Components/Pages/Registation';
import Privacypolicy from './Components/privacypolicy/privacypolicy';
import Session from './Components/Sessions/Session';
import Session1 from './Components/Pages/session1';
import Session2 from './Components/Pages/session2';
import Session3 from './Components/Pages/session3';
import Session4 from './Components/Pages/Session4';
import Session5 from './Components/Pages/Session5';
import FeedbackForm from './Components/Sessions/FeedbackForm';
import GetQuestions from './Components/Pages/Getquestions';
import Dashboard from './Components/Sessions/Dashboard';
import SessionTopic from './Components/Sessions/SessionTopic';
import SesionFeedback from './Components/Sessions/SesionFeedback';
import Form1 from './Components/Forms/Form1';
import Formdashboard from './Components/Forms/Formdashboard';
import Form3f1 from './Components/Forms/Form3f1';
import Form3f2 from './Components/Forms/Form3f2';
import Form3f3 from './Components/Forms/Form3f3';
import Form3f4 from './Components/Forms/Form3f4';
import Form3f5 from './Components/Forms/Form3f5';
import Form3f6 from './Components/Forms/Form3f6';
import Form3f7 from './Components/Forms/Form3f7';
import Form3f8 from './Components/Forms/Form3f8';
import Form3f9 from './Components/Forms/Form3f9';
import Form2 from './Components/Forms/Form2';
import Form3f10 from './Components/Forms/Form3f10';
import Login from './Components/Signup/Login';
import Form3f12 from './Components/Forms/Form3f12';
import AwardNominationData from './Components/Sessions/AwardNominationData';

function App() {

  return (
    <Router>
      <Routes>
        <Route path='/registation-Registation' element={<Registation />} />
        <Route path='/dashboard-Dashboard/34g-54fg-fgrr/dashboard' element={<Dashboard />} />
        <Route path='/login' element={<Login />} />
        <Route path='/feedback-form' element={<SesionFeedback />} />
        <Route path='/session-topic' element={<SessionTopic />} />
        <Route path='/privacypolicy' element={<Privacypolicy />} />
        <Route path='/session1/Spirutal-Dimension-of-Leadership' element={<Session1 />} />
        <Route path='/session2/Scaling-the-Business' element={<Session2 />} />
        <Route path='/session3/Panel-Discussion' element={<Session3 />} />
        <Route path='/session4/Leadership-Imperatives' element={<Session4 />} />
        <Route path='/session5/Technology-in-Healthcare' element={<Session5 />} />
        <Route path='/DataGetQuestions/sessions-in-GetQuestions' element={<GetQuestions />} />

        <Route path='/session/:id/sessionForm' element={<Session />} />

        <Route path='/FeedbackForm/:id/feedbackForm-in-feedbackForm' element={<FeedbackForm />} />

        <Route path='/' element={<Formdashboard />} />
        <Route path='/form-form1' element={<Form1 />} />
        <Route path='/form-form2' element={<Form2 />} />
        <Route path='/form-form3f1' element={<Form3f1 />} />
        <Route path='/form-form3f2' element={<Form3f2 />} />
        <Route path='/form-form3f3' element={<Form3f3 />} />
        <Route path='/form-form3f4' element={<Form3f4 />} />
        <Route path='/form-form3f5' element={<Form3f5 />} />
        <Route path='/form-form3f6' element={<Form3f6 />} />
        <Route path='/form-form3f7' element={<Form3f7 />} />
        <Route path='/form-form3f8' element={<Form3f8 />} />
        <Route path='/form-form3f9' element={<Form3f9 />} />
        <Route path='/form-form3f10' element={<Form3f10 />} />
        <Route path='/form-form3f12' element={<Form3f12 />} />

        <Route path='/awards-nomination' element={<AwardNominationData />} />
      </Routes>
    </Router>
  );
}

export default App;
